<template>
  <v-app id="reset">
    <v-main class="background-login">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex>
                <logo />
              </v-flex>
              <v-flex class="" v-if="mobilePanel == 1">
                <v-row align-center>
                  <v-col class="d-flex justify-center" align-self="center" md="6" xs="12">
                    <v-btn color="primary" elevation="2" large @click="login()"> Ir a la página web</v-btn>
                  </v-col>
                  <v-col class="d-flex justify-center" md="6" xs="12">
                    <v-btn color="primary" elevation="2" large @click="mobile()">Ir a la app móvil</v-btn>
                  </v-col>
                </v-row>
              </v-flex>
              <v-flex d-flex justify-center align-center v-if="mobilePanel == 2">
                <a href="https://play.google.com/store/apps/details?id=com.konect&hl=es_MX&gl=es">
                  <v-img lazy-src="../../assets/google-play-badge.png" max-height="50" max-width="150" src="../../assets/google-play-badge.png"></v-img>
                </a>
                <a href="https://apps.apple.com/mx/app/ruta-k/id1532968856">
                  <v-img lazy-src="../../assets/app-store-badge.svg" max-height="50" max-width="120" src="../../assets/app-store-badge.svg"></v-img>
                </a>
              </v-flex>
              <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                {{ msgError }}
              </v-snackbar>
              <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
                {{ msgSuccess }}
              </v-snackbar>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <main-footer />
  </v-app>
</template>

<script>
import logo from "@/components/Logo";
import mainFooter from "@/components/Footer";

export default {
  name: "recovery",
  components: { logo, mainFooter },
  data: () => ({
    error: false,
    msgError: "",
    success: false,
    msgSuccess: "",
    mobilePanel: 1,
  }),
  mounted() {},
  computed: {},
  methods: {
    login() {
      this.$router.push("/login");
    },
    mobile() {
      this.mobilePanel = 2;
    },
  },
};
</script>

<style scoped>
.background-login {
  background-color: white !important;
}
</style>
